import { formatNum } from '@app/utils/math';
import IconPercentageArrowDown from '@shared/icons/IconPercentageArrowDown';
import IconPercentageArrowUp from '@shared/icons/IconPercentageArrowUp';

type Props = {
  gapFromFirst: number;
  isLeader: boolean;
};

export const LeaderCell = ({ gapFromFirst, isLeader }: Props) => {
  const Icon = isLeader ? IconPercentageArrowUp : IconPercentageArrowDown;
  const text = isLeader ? 'Лидер' : formatNum(gapFromFirst);
  const colorClass = isLeader ? 'text-green-500' : 'text-red-500';

  return (
    <div className={`flex items-center gap-2 ${colorClass}`}>
      <Icon />
      <span className="font-medium">{text}</span>
    </div>
  );
};
